import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_116: FaireProductEntity = {
  token: "legacy_prod_abbott-116",
  type: "product",
  name: "Beehive Covered Pot",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/e62fa66f032d18ef74fa0e6973b05c863e0de56b4eed6ebcd6fa9c23790f9f85.jpeg",
  priceDollars: 22,
  subcategory: "Serveware",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
